import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StickyCall from "../components/StickyCall";
import { MapPin, ChevronRight } from "lucide-react";
import { villesSEO, REGIONS } from "../villes";

export default function Blog() {
  return (
    <div data-testid="villes-page">
      <Header />
      <StickyCall />

      <section className="hero-radial py-14 md:py-20">
        <div className="container-narrow text-center max-w-3xl mx-auto">
          <p className="text-[11px] uppercase tracking-[0.3em] text-gold-deep mb-3">Guide par commune</p>
          <h1 className="font-display text-4xl md:text-5xl gold-gradient-text">Marabout à Orléans, dans le Loiret et les villes voisines</h1>
          <div className="gold-divider my-5 max-w-[220px] mx-auto" />
          <p className="text-gold-soft/95 leading-relaxed">
            Trouvez Maître Diamma près de chez vous : marabout, sorcier puissant, voyant et guérisseur africain à Orléans, dans les 22 communes de la métropole, le Loiret et les villes voisines. Retour affectif, désenvoûtement, magie blanche et voyance.
          </p>
        </div>
      </section>

      <section className="py-14 md:py-16 bg-charcoal">
        <div className="container-narrow space-y-10">
          {REGIONS.map(({ key: region, label }) => (
            <div key={region}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg gold-border flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-gold" />
                </div>
                <h2 className="font-display text-lg text-gold">{label}</h2>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {villesSEO.filter((v) => v.region === region).map((v) => (
                  <Link key={v.slug} data-testid={`ville-card-${v.slug}`} to={`/marabout/${v.slug}`} className="card-onyx rounded-xl p-5 flex items-center justify-between group">
                    <div>
                      <div className="font-display text-gold text-lg">Marabout à {v.nom}</div>
                      <div className="text-xs text-gold-deep mt-0.5">{v.cp} • Sorcier • Retour affectif • Voyance</div>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gold group-hover:translate-x-1 transition-transform" />
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
